"use client";
import { StandardProps } from "../../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { isAvailableToOrder } from "@/utils/product/isAvailableToOrder.ts";
import { GridGalleryUI } from "./GridGalleryUI";
import { GalleryContextProvider } from "../context/GalleryContext";
import {
  hasSocialProofMessages,
  videoPreloadValues,
} from "@/components/Galleries/utils.ts";
import { parseFlagEnumValue } from "@/utils/flags/parseFlagEnumValue.ts";

export const GridGallery = (
  props: Pick<
    StandardProps,
    | "product"
    | "configProps"
    | "flags"
    | "experiencesRawObject"
    | "runtimeConfig"
  > & { sizes: string },
) => {
  const {
    product,
    sizes,
    configProps,
    flags,
    experiencesRawObject,
    runtimeConfig,
  } = props;
  const { variant } = useVariant(product);

  const videoPreload = parseFlagEnumValue(
    flags.videoPreload?.value,
    videoPreloadValues,
    "auto",
  );

  const pdpAsLanding = configProps?.pdpAsLanding === true;

  if (!variant) return null;

  const media = "media" in product ? product.media : null;

  const videos = media?.videos || [];

  const title = variant.title;

  const images = variant.images;

  const spm = hasSocialProofMessages(configProps)
    ? configProps.SocialProofMessages
    : undefined;
  const socialProofMessagesProperties =
    product.__typename === "SimpleProduct" && spm
      ? {
          appId: spm.appId ?? "",
          withClose: spm.withClose,
          productId: product.aliases.pimProductId,
          brand: product.brand.name,
          availableToOrder: isAvailableToOrder(product),
          experiencesRawObject,
          showSocialProofMessages: flags.showSocialProofMessages.value === true,
          monetateEnvironment: runtimeConfig.monetateEnvironment,
          reduceSocialProofMessagesPersistence:
            flags.reduceSocialProofMessagesPersistence.value === true,
        }
      : undefined;

  const amendCarouselZoomIcon = flags.amendCarouselZoomIcon?.value;

  return (
    <GalleryContextProvider {...props}>
      <GridGalleryUI
        title={title}
        images={images}
        videos={videos}
        sizes={sizes}
        hasSocialProofMessagesExperience={true}
        socialProofMessagesProperties={socialProofMessagesProperties}
        hasSuperZoom={!flags.isSuperZoomDisabled.value}
        usePrefetching={!!flags.usePrefetching.value}
        useResponsiveImages={!!flags.useResponsiveImages.value}
        pdpAsLanding={pdpAsLanding}
        videoPreload={videoPreload}
        carouselGalleryInpTest={flags.carouselGalleryInpTest.value === true}
        galleryImageZoomOnHover={flags.galleryImageZoomOnHover.value === true}
        experiencesRawObject={experiencesRawObject}
        runtimeConfig={runtimeConfig}
        amendCarouselZoomIcon={amendCarouselZoomIcon}
      />
    </GalleryContextProvider>
  );
};
